import React from 'react';
import './AnomalityBadge.css';

const AnomalityBadge = ({ anomality, showValue = true, size = 'medium' }) => {
  if (anomality === null || anomality === undefined) {
    return null;
  }

  const anomalityValue = Number(anomality);
  
  // Определяем цвет на основе значения аномальности
  const getBadgeColor = (value) => {
    if (value <= 0.3) return 'green';
    if (value <= 0.7) return 'orange';
    return 'red';
  };

  // Определяем текст бейджа
  const getBadgeText = (value) => {
    if (value <= 0.3) return 'Норма';
    if (value <= 0.7) return 'Средняя';
    return 'Высокая';
  };

  const color = getBadgeColor(anomalityValue);
  const text = getBadgeText(anomalityValue);

  return (
    <div className={`anomality-badge anomality-badge--${color} anomality-badge--${size}`}>
      <span className="anomality-badge__text">{text}</span>
      {showValue && (
        <span className="anomality-badge__value">
          {anomalityValue.toFixed(3)}
        </span>
      )}
    </div>
  );
};

export default AnomalityBadge; 